"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _labelLike = _interopRequireDefault(require("./label-like"));

var _inputGroup = _interopRequireDefault(require("./input-group.css"));

var InputGroup = function InputGroup(_ref) {
  var _clsx;

  var inline = _ref.inline,
      children = _ref.children,
      className = _ref.className,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_inputGroup["default"].inputGroup, (_clsx = {}, _clsx[_inputGroup["default"].inline] = inline, _clsx), className)
  }, title && /*#__PURE__*/_react["default"].createElement(_labelLike["default"], {
    inline: inline
  }, title), children);
};

var _default = InputGroup;
exports["default"] = _default;